// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles__grid___g9zii","title":"styles__title___1ZFXv","subtitle":"styles__subtitle____V4oh"};